import store from "@/store";

export const roles = (arr, text) => {
  try {
    const { roles } = store.state.app;
    let names = "";
    if (arr.length)
      arr.forEach(r => {
        if (roles[r])
          text
            ? (names += roles[r].name + " ")
            : (names += `<span class="label role-${r}"> ${roles[r].name}</span>`);
      });
    return names;
  } catch (e) {
    void e;
  }
};
export const directions = (arr, text) => {
  try {
    const { directions } = store.state.app;
    let names = "";
    if (arr.length)
      arr.forEach(r => {
        if (directions[r])
          text
            ? (names += directions[r].name + " ")
            : (names += `<span> ${directions[r].name}</span>`);
      });
    return names;
  } catch (e) {
    void e;
  }
};
